import { render, staticRenderFns } from "./PhoneMockup.vue?vue&type=template&id=1f15ce3e&scoped=true&"
import script from "./PhoneMockup.vue?vue&type=script&lang=ts&"
export * from "./PhoneMockup.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneMockup.vue?vue&type=style&index=0&id=1f15ce3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15ce3e",
  null
  
)

export default component.exports